import User from "../../models/user";

const Process = (state = User, action) => {
    switch (action.type) {
        case 'inscripcion':
            return {
                ...state,
				...action.user
            }
    
        default:
            return state;
    }
}

export default Process;